import uniqueId from '@form-create/utils/lib/unique';
import { makeRequiredRule } from '../../utils';
var label = '单行文本';
var name = 'input';
export default {
  icon: 'iconfont icondanhangwenben1',
  label: label,
  name: name,
  rule: function rule() {
    return {
      type: name,
      field: uniqueId(),
      title: label,
      info: '',
      props: {}
    };
  },
  props: function props() {
    return [makeRequiredRule()];
  },
  basic: function basic() {}
};